module.exports = __webpack_public_path__ + "static/Ettercap-229f4d2ca5208d529e3087ddbc627d7b.jpg";